var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.59,
    height: 20.051,
    viewBox: "0 0 21.59 20.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Wallet",
    "data-name": "Iconly/Light/Wallet",
    transform: "translate(-1.75 -2.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallet",
    transform: "translate(2.5 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M7.075,5.65H2.826a2.825,2.825,0,1,1,0-5.65H7.075",
    transform: "translate(13.015 6.312)",
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M.627.456H.3",
    transform: "translate(15.694 8.617)",
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M5.508,0h9.073A5.509,5.509,0,0,1,20.09,5.508v7.534a5.509,5.509,0,0,1-5.508,5.508H5.508A5.509,5.509,0,0,1,0,13.042V5.508A5.509,5.509,0,0,1,5.508,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_7",
    "data-name": "Stroke 7",
    d: "M0,.456H5.667",
    transform: "translate(4.761 4.308)",
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.11f64033be18c1081b08e307823a9965.svg";
export { ForwardRef as ReactComponent };